import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=04f6ed64&"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js&"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports